const BMCB_REGEX = /^\d+(\/\d+)*$/;
export default BMCB_REGEX;
